import { render, staticRenderFns } from "./WorkTitle.vue?vue&type=template&id=96373710&"
import script from "./WorkTitle.vue?vue&type=script&lang=js&"
export * from "./WorkTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports